import { getTokenFromLocalStore } from "utils";
import { useEffect, useState } from "react";
import { IUserDetails } from "types";

export function useUser() {
  const [user, setUser] = useState<IUserDetails | any>(null);

  useEffect(() => {
    const userDet = getTokenFromLocalStore<IUserDetails>("user_details");
    if (userDet) {
      setUser(userDet);
    }
  }, []);

  return { user, setUser };
}
